module.exports = __webpack_public_path__ + "static/media/temoignages-mobile.ddccec7e.svg";